import {useIntl} from "react-intl";
import Input from "@ui-components/Input";
import Textarea from "@ui-components/Textarea";
import Toggle from "@ui-components/Toggle";
import React from "react";
import {ContentsEditorProps} from "./types";
import {MAX_DESCRIPTION_LENGTH} from "./lib/consts";

export const ContentsEditor = ({
  title,
  setTitle,
  description,
  setDescription,
  includeNotes,
  setIncludeNotes,
}: ContentsEditorProps) => {

  // hooks
  const intl = useIntl();

  // utilities
  const getLabel = (id: string, maxChars: number | null = null) => {
    const clauses = [
      ...(maxChars ? [intl.formatMessage({id: "max_chars"}, {maxChars}).toLowerCase()] : []),
    ];
    return `${intl.formatMessage({id})}${clauses.length > 0 ? " (" + clauses.join(", ") + ")" : ""}`
  }
  const getPlaceholder = (optional=false) => {
    const clauses = [
      ...(optional ? [intl.formatMessage({id: "optional"}).toLowerCase()] : []),
    ];
    const text = intl.formatMessage({id: "insert_text_here"});
    return `${text}${clauses.length > 0 ? " (" + clauses.join(", ") + ")" : ""}`
  }

  return (
    <div className="flex flex-col gap-4">
      {/* @ts-ignore */}
      <Input
        name="report-title"
        label={getLabel("title")}
        value={title || ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
        showErrorDialog={false}
        placeholder={getPlaceholder(true)}
      />
      <Textarea
        name="report-description"
        label={getLabel("description", MAX_DESCRIPTION_LENGTH) as any}
        value={description || ""}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
        rows={3}
        hideBottomMargin={true}
        maxLength={MAX_DESCRIPTION_LENGTH}
        placeholder={getPlaceholder(true)}
        textCls="text-sm"
      />
      <Toggle
        label={intl.formatMessage({id: "include_notes"})}
        description={undefined}
        checked={includeNotes}
        onChange={() => setIncludeNotes((prev) => !prev)}
        vertical={false}
      />
    </div>
  )
}